import { ShoppingCartIcon } from 'lucide-react';

import Link from 'next/link';
import { useCartContext } from '@/utils/hooks/cart/useCartContext';

export default function AccessBarCart() {
  const { cartCount } = useCartContext();

  return (
    <Link
      href="/cart"
      className="group relative outline-none"
      aria-label="Cart"
    >
      <ShoppingCartIcon
        className="h-[22px] w-[22px] transition duration-100 ease-in-out group-hover:scale-105"
        strokeWidth={1.7}
      />
      {cartCount > 0 && (
        <span className="absolute -right-2.5 -top-2.5 flex h-5 w-5 items-center justify-center rounded-full bg-teal-500 text-xs font-bold leading-none text-gray-700">
          {cartCount}
        </span>
      )}
    </Link>
  );
}
